<template>
  <div class="page">
    <initio-panel @submit-handler="submitHandler" :errors="errors">
      <template v-slot:title>Claim History</template>
      <template v-slot:label>
        <div class="notification is-info-blue">
          <p class="is-size-4">You have advised us of <strong>{{ answers['Vehicle.Confirm'].vehicle_confirm_driver_claim_count }} vehicle claim<template v-if="answers['Vehicle.Confirm'].vehicle_confirm_driver_claim_count > 1">s</template></strong> in the past 5 years, where the owner or main driver paid the excess. Can you please tell us more?</p>
          <p class="pt-4 pb-4">We are not concerned with Glass or Keys &amp; Locks claims, so there is no need to provide the details for these.</p>
          <p><router-link :to="{ name: 'Vehicle.Confirm'}">Change my number of claims</router-link></p>
        </div>
      </template>
      <template v-slot:sidebar>
        <initio-summary class="info-box" />
        <disclosure-block />
        <template v-html="item"></template>
      </template>
    </initio-panel>
  </div>
</template>

<script>

import InitioPanel from '@/components/initio/InitioPanel.vue'
import InitioSummary from '@/components/partials/Summary.vue'
import stepSubmit from '@/mixins/stepSubmit.js'
import { mapGetters } from 'vuex'
import DisclosureBlock from "../../partials/DisclosureBlock";

export default {
  components: {
    DisclosureBlock,
    InitioPanel,
    InitioSummary
  },
  mixins: [
    stepSubmit
  ],
  computed: {
    ...mapGetters({ currentSession: 'currentSession', answers: 'flattenedAnswers'}),
  },
  beforeMount () {

      this.$store.commit('updateSchema', []);

      let data_combined = [];
      let j = 0;

      if ( this.currentSession.answers['Vehicle.Confirm'].vehicle_confirm_driver_claim_count > 0 ) {

        for (let i=0; i < this.currentSession.answers['Vehicle.Confirm'].vehicle_confirm_driver_claim_count; i++) {
          // how many loops?

          this.$store.dispatch('getSchema', 'new/driver-claim-history' )
            // .then(response => {
            //   this.$store.commit('updateSchema', response);
            // })
            .then(data => {

              j++;

   
              function recursiveReplace(element){
                // console.log(element);
                // console.log(index);
                // console.log(array);

                //console.log( element.forEach(recursiveReplace) );
                element.name = element.name + '_' + j;
                if (element.label == 'Claim ') {
                  element.label = element.label + j;
                }

                for (let [key, value] of Object.entries(element)) {
                  // console.log(key);
                  // console.log(value);
                  //if (value)
                  // if (typeof(value) == 'object') {
                    //value.forEach(recursiveReplace);
                  // }
                  if ( key == 'name' || key == 'id' ){
                    value = value + '_' + j;
                  }

                  // add loop to conditional keys
                  if ( key == 'conditional' ) {
                    value.forEach(function(element,index,array){
                      array[index].on = array[index].on + "_" + j;
                    })
                  }

                  if ( key == 'children' || key == 'options' ) {
                    // loop through children / options
                    if ( Array.isArray(value) ) {
                      value.forEach(recursiveReplace);
                    } else {
                      if (element.component == 'h3') {
                        element.children = element.children + '' + j;
                      }
                      // if (element.type == 'h3') {

                      //   // TODO: HERE
                      //   const regex = /{{[\s]+?(.*)[\s]+?}}/ig;
                        
                      //   element.children = element.children.replaceAll(regex, " variable replacement ($1) _ " + j);
                        
                      // }
                    }
                  }
                }
              }

              console.log('Debug data', data);
              // recursively loop through all data
              data.forEach(recursiveReplace);

              data_combined.push( data[0] );

              this.$store.commit('updateSchema', data_combined);
            });

        }

      } else {
        // skip this step
        this.$router.push({name: 'Vehicle.Payment' });
        return false;
      }
  },
  methods: {
    submitHandler() {
      let context = this;

      this.genericSubmitHandler()
        .then(response => {
          // console.log(response)
        }, error => {
          console.error("VehicleDriverClaimHistory Handler error", error); // Unsure if we need this or not, remove if not needed
          context.errors = error;
        });
    }
  },
  data () {
    return {
      errors: [],
      schema: [],
    }
  },
}

</script>

<style lang="scss">
  h3[name^=claim_title_] {
    font-size:1.5rem;
    font-weight:900;
  }
</style>